export enum MoneyMovementOperationTypes {
  Onramp = 'onramp',
  Offramp = 'offramp',
  CrossChainTransfer = 'crossChainTransfer',
  OnChainTransfer = 'onChainTransfer',
}
